import React, {
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BasicSpeech from "./BasicSpeech";
import Bubble from "../../assets/icons/icon_bubble.png";
import { MyContext } from "../../context/MyContext";
import { backIncstance, checkGroupId } from "../../utils/commonFunctions";
import { UseViewToBottom } from "../../hooks/useScroll";

import Warning from "../../components/Warning";
import SelectBox from "../../components/SelectBox";
import Sample from "../../components/Sample";
import Chat from "./components/Chat";
import styled from "styled-components";
import CreateUrl from "../../components/CreateUrl";
import LoadingForm from "./components/loading/LoadingForm";
import SharedChatInput from "./components/SharedChatInput";
import {
  handleClarioAbort,
  handleSearchHistory,
  handleUpdateHistory,
} from "../../utils/handleChatting";
import { postClario } from "../../api/postClario";
import CONSTANTS from "../../constants";

const URLS = {
  CREATE_URL: process.env.REACT_APP_TUTOR_SHARE_LINK,
  CLARIO: process.env.REACT_APP_CLARIO_SERVER,
  NAVER: process.env.REACT_APP_NAVER_SEARCH,
  REACTION: process.env.REACT_APP_TUTOR_EVALUATION,
  CHAT_HISTORY: process.env.REACT_APP_BACK_TUTOR_HISTORY, // 튜터 그룹 채팅에 대화 추가
  GROUP_LIST: process.env.REACT_APP_TUTOR_GET_GROUP_LIST, // 튜터 그룹 목록클릭시 상세 글 조회
  EDIT_GROUP_LIST: process.env.REACT_APP_TUTOR_EDIT_GROUP_LIST, // 튜터 채팅 목록 조회, 생성, 수정, 삭제
  GET_STORAGE_LIST: process.env.REACT_APP_TUTOR_GET_STORAGE_LIST,
  RESET_CHAT_HISTORY: process.env.REACT_APP_TUTOR_RESET_HISTORY,
  ADD_GROUP: process.env.REACT_APP_TUTOR_GET_HISTORY_LIST, // 튜터 그룹 추가, 채팅 목록 조회
  EDIT_STORAGE: process.env.REACT_APP_TUTOR_EDIT_STORAGE_LIST, // 튜터 보관함 생성
  STORAGE_HISTORY: process.env.REACT_APP_TUTOR_GET_STOARGE_GROUP_LIST, // 보관함의 채팅 내역을 가져오는 API
  PROMPT_MSG: process.env.REACT_APP_PROMPT,
  GREETING_MSG: process.env.REACT_APP_GREETING_MSG,
  PERSONA: process.env.REACT_APP_SETTINGS_GET_PERSONA_LIST,
};

const EMPTY = /^\s*$/;

const REG_ABORT = /Cancel/;
const NO_PASS_USER = `과학동아AiR PASS를 구매하시고, 자유롭게 이용하세요!`;

/**
 * todo
 * 1. API 호출 코드 정리 진행중 (CHAT_HISTORY POST까지 진행함, 확인 필요)
 *
 */

const Tutor = () => {
  const {
    openNav,
    setAlertSetting,
    isMobile,
    setUser,
    pageName,
    user,
    history,
    setHistory,
    isUpdate,
    setIsUpdate,
    paramId,
    setParamId,
    fetching,
    setFetching,
    setList,
    setIsLogin,
    isFreeScroll,
    setIsFreeScroll,
    controllerRef,
    searchContent,
    setSearchContent,
    setIntroText,
    introTextRef,
    pieceDataSumRef,
    setIsUpdateList,
    setPieceDataSum,
    introListRef,
    setIsClickedHistory,
    setIsOpenTicketAlert,
  } = useContext(MyContext);

  const location = useLocation();
  const navigation = useNavigate();

  const [prompt, setPrompt] = useState("");
  const [isToggle, setIsToggle] = useState(false);

  const searchRef = useRef("");
  const scrollRef = UseViewToBottom(isUpdate); // scroll 영역 따라감
  const backupInput = useRef(""); // api 에러시 대화 이력에 저장할 사용자 입력 값
  const feedbackRef = useRef(Array(history.length).fill(null)); // 피드백 입력값

  const [wordLng, setWordLng] = useState(0);

  const [promptValue, setPromptValue] = useState("대화하듯이 질문해주세요.");
  const [welComeVAlue, setWelcomeValue] = useState({
    id: 1,
    kind: "tutor",
    greeting: "",
  });
  // 추천 질의를 통한 API 호출 여부 구분
  const [isRecommended, setIsRecommended] = useState(false);

  // 유효한 로그인 상태인지 확인하는 함수
  const isValidLogin = () => {
    return !!(user && user.id);
  };

  const moveToLogin = () => {
    if (!isValidLogin()) {
      window.location.assign(
        `${process.env.REACT_APP_LOGIN_URL}/?referer_url=${process.env.REACT_APP_REFERER_URL}/tutor`
      );
    }
  };

  const setTextFunction = (text) => {
    setPrompt(text);
  };

  useEffect(() => {
    if (prompt) {
      searchRef.current = prompt;
    }
  }, [prompt]);

  // URL의 쿼리스트링을 읽어와 inputRef 값에 추가하는 useEffect
  useEffect(() => {
    // URL에서 쿼리스트링 파라미터 추출
    const queryParams = new URLSearchParams(location.search);
    const queryText = queryParams.get("query");

    // 쿼리 파라미터가 존재하면 inputRef에 설정
    if (queryText) {
      setPrompt(decodeURIComponent(queryText));
    }
  }, [location.search]); // location.search가 변경될 때마다 실행

  /**
   * 요청 중단
   * @returns stop fetching
   */
  const handleAbort = () => {
    if (fetching && controllerRef.current) {
      controllerRef.current.abort();
      setFetching(false);
    }
  };
  const handleError = (response) => {
    const txt = `${
      response?.detail ? response?.detail : "이용중인 상품이 없습니다."
    }\n 결제페이지로 이동하시겠습니까?`;
    if (response.status === 401) {
      setAlertSetting((prev) => ({
        ...prev,
        alertTxt: txt,
        double: true,
        btnTxt: "이동하기",
        onConfirm: () => {
          if (typeof prev.onConfirm === "funtion") {
            prev.onConfirm();
          }
          navigation("/login", {
            state: {
              is_completed: false,
              is_writed: false,
              from_chat: null,
              his_cnt: 0,
            },
          });
        },
      }));
      // 결제 로직 변경
      // } else if (response.status === 403 || response.status === 404) {
    } else if (response.status === 403) {
      setAlertSetting((prev) => ({
        ...prev,
        alertTxt: txt,
        double: true,
        btnTxt: "이동하기",
        onConfirm: () => {
          if (typeof prev.onConfirm === "funtion") {
            prev.onConfirm();
          }
          navigation("/settings/products", {
            state: {
              is_completed: false,
              is_writed: false,
              from_chat: null,
              his_cnt: 0,
            },
          });
        },
      }));
    }
  };

  /**
   * 함수명: touchAPI
   * 기능: API 전체 관리
   * 처리: url 주소 별로 요청 성공시 이벤트 분기
   * @param {메소드} method
   * @param {API 주소} url
   * @param {요청 데이터} data
   */
  const touchAPI = async (method, url, data) => {
    try {
      const response = await backIncstance(method, url, data);
      if (response) {
        if (
          (response.status === 401 && url !== URLS.PERSONA) ||
          response.status === 403 ||
          response.status === 404
        ) {
          handleError(response);
          return;
        } else {
          const resData = await response?.json();
          return resData;
        }
      }
      /// 삭제
    } catch (err) {
      return;
    }
  };

  // 관리자페이지에서도 max는 20이하로 해요???

  // clario 통신 완료시 back-end에 대화 이력 전송
  const deliverResult = async (data) => {
    if (isReloadRef.current && data.response_id) {
      const myIdx = history.length - 1;
      data.response_id =
        history[myIdx]?.response_id || new Date().getTime().toString();
      // data.id = history[myIdx]?.id;
    }
    let reqData;

    if (data.user_pk) {
      data.user_pk = user.id;
    }
    reqData = data;
    if (data === "error") {
      reqData = history[history?.length - 1];
      if (!reqData || !reqData.latency) {
        reqData = {
          action: "chat",
          input_text: searchContent || backupInput.current,
          ip_address: "0.0.0.0",
          latency: 0,
          recommended_questions: [],
          reference: [],
          response: "다시 시도해주세요.",
          response_id: new Date().getTime().toString(),
          id: new Date().getTime().toString(),
          introText: [],
          introList: [],
          type: "all",
          images: [],
          token_count: 1,
          user_eva: {
            simple_eva: null,
          },
        };
      } else {
        reqData = {
          ...reqData,
          ip_address: "0.0.0.0",
          token_count: 1,
          response: "다시 시도해주세요.",
        };
      }
    }
    // touchAPI('POST', URLS.CHAT_HISTORY, data)
    const addChat = await touchAPI(
      isReloadRef.current ? "PATCH" : "POST",
      URLS.CHAT_HISTORY,
      reqData
    );
    if (addChat) {
      const jsonData = checkGroupId();
      const reqData = {
        group_id: Number(jsonData.params),
        response_id: addChat.response_id
          ? addChat.response_id
          : history[history?.length - 1].response_id,
      };
      const addGroup = await touchAPI("POST", URLS.ADD_GROUP, reqData);
      if (addGroup.id) {
        setParamId(addGroup.id);
      }
      backupInput.current = ""; // api 저장후에 질문 값 초기화
    }
  };

  // textarea 입력값, clario에 전송하는 요청 객체
  const [queryString, setQueryString] = useState({ query: "", messages: [] });
  /**
   * 사용자 질문값을 이용해 clario의 답변을 받아옴
   * @param {최초화면에서 추천질의어 클릭시 true : false} type
   * @param {사용자 질문 값} data
   */

  const fetchData = async (url, type, data, group_id) => {
    if (!isValidLogin()) return;

    setPrompt("");
    searchRef.current = "";
    const abortController = new AbortController();
    controllerRef.current = abortController;
    setFetching(true);
    setIsFreeScroll(false);
    let isAuto = type !== undefined ? true : false;
    // const isAuto = history.length === 0 ? true : false;

    let copy = [...history];

    if (isAuto) {
      const reqData = {
        // user_pk: user.id,
        title: data,
        group_id: Number(group_id),
      };
      if (!reqData.group_id) {
        return;
      }
      if (history.length === 0) {
        const editData = await touchAPI("PATCH", URLS.EDIT_GROUP_LIST, reqData);
        if (editData) {
          setIsUpdateList(true);
        }
      }
    }
    let myIdx = copy.length === 1 ? 0 : copy.length - 1;
    // let formData = !isAuto ? queryString.query : data;
    let formData = !isAuto ? queryString.query : data;
    try {
      // const result = await postClario(
      //     formData,
      //     handleTextControl,
      //     abortController,
      //     history,
      //     user?.tone,
      // )
      const result = await postClario(
        formData,
        handleTextControl,
        abortController,
        history,
        user?.tone,
        isRecommended
      );
      if (result === "aborted") {
        handleClarioAbort(
          searchContent || backupInput.current,
          pieceDataSumRef.current,
          setHistory,
          introTextRef.current,
          introListRef.current,
          isReloadRef.current
        );
        streamEnd("error");
      }
    } catch (err) {
      const isAbort = REG_ABORT.test(err);
      let text;
      if (
        copy[myIdx].input_text === "" ||
        copy[myIdx].input_text === undefined ||
        copy[myIdx].input_text === null
      ) {
        if (history.length === 1) {
          setHistory([]);
        } else {
          // setHistory((prev) => prev.slice(0, -1));
        }
        text = history[history.length - 1]?.response;
      } else if (isAbort) {
        handleAbort();
        // streamEnd('error')
      }
      // setHistory((prev) => {
      //     const copy = [...prev];
      //     copy[myIdx].action = "error";
      //     copy[myIdx].response = "다시 시도해주세요.";
      //     return copy;
      // });
    } finally {
      setFetching(false);
      setIsFreeScroll(false);
      setIsRecommended(false);
    }
  };
  // AI 작성된 마지막 응답 처리(+에러처리)
  const streamEnd = useCallback(
    async (item) => {
      if (item !== "error") {
        if (isReloadRef.current) {
          const lastIdx = history?.length - 1;
          const record = history[lastIdx];
          const target = {
            id: record?.id || new Date().getTime().toString(),
            response_id: record?.response_id || new Date().getTime().toString(),
            last_result: item.last_result,
            recommended_questions: item.recommended_questions,
            latency: item.latency,
            input_text: item.input_text,
            reference: item.reference,
            response: item.response,
            images: item.images,
            action: item.action,
            sub_action: item.sub_action,
            question_count: item.question_count,
            followup_count: item.followup_count,
            from_chat: item.from_chat,
            user_eva: item.user_eva,
          };
          handleUpdateHistory(
            target,
            setHistory,
            introTextRef.current,
            introListRef.current
          );
        } else {
          handleSearchHistory(
            item,
            pieceDataSumRef.current,
            setHistory,
            introTextRef.current,
            searchContent || backupInput.current,
            introListRef.current
          );
        }
      }

      deliverResult(item);
      setFetching(false);
      setPieceDataSum("");
      setIntroText([]);
      introListRef.current = [];
      introTextRef.current = [];
      pieceDataSumRef.current = "";
      setSearchContent("");
      isReloadRef.current = false;
      // abortControllerRef.current = null;
      setTimeout(() => {
        window.scrollTo({
          top: document.body.scrollHeight,
          behavior: "smooth",
        });
      }, 400);
    },
    [pieceDataSumRef]
  );

  const handleTextControl = (item) => {
    if (item?.type === "all") {
      streamEnd(item);
      return;
    }
    if (item?.status_code === 501) {
      streamEnd("error");
      return;
    }
    if (
      item?.type === "main" ||
      item?.type === "sub" ||
      item?.type === "DONE" ||
      item?.type === "FINISH"
    ) {
      item.id = new Date().getTime().toString();
      setIntroText((prev) => [...prev, item]);
      introTextRef.current = [...introTextRef.current, item];
      introListRef.current = [...introListRef.current, item];
      return;
    }
    if (item.text) {
      let newText = item.text; // 현재 item.text를 저장
      if (item.text === "†") {
        newText = "";
      }
      setPieceDataSum((prev) => {
        let updatedSum = prev + newText;

        if (updatedSum.match(/<br>\|\s*$/)) {
          updatedSum = updatedSum.replace(/<br>\|\s*$/, "\n|");
        }
        if (updatedSum.match(/\|<br><br>$/)) {
          updatedSum = updatedSum.replace(/\|<br><br>$/, "| \n\n");
        }

        pieceDataSumRef.current = updatedSum;
        return updatedSum;
      });
    }
  };

  const handleLinkToProducts = (e) => {
    e.preventDefault();
    setIsOpenTicketAlert(true);
    return;
  };

  const handleCopy = () => {
    setWarnSetting({
      ...warnSetting,
      warningTxt: "내용이 복사되었습니다.",
    });
  };

  const handleSample = async (data) => {
    if (!isValidLogin()) {
      moveToLogin();
      return;
    }
    if (fetching) {
      return false;
    }
    if (user.tutor_cnt === 0) {
      setIsOpenTicketAlert(true);
      return;
    }
    // paramId가 없으면 클라리오 통신
    if (!paramId) {
      const reqData = {
        // user_pk: user.id,
        title: data,
      };
      const addData = await touchAPI("POST", URLS.EDIT_GROUP_LIST, reqData);
      if (addData) {
        if (!paramId) {
          setParamId(addData.id);
          navigation(`/${pageName}/${addData.id}`, {
            state: {
              from_chat: "new",
              his_cnt: 0,
              is_writed: false,
              is_completed: false,
            },
          });
        }
        getGroupList(URLS.GROUP_LIST);
      }
    }

    // await fetchData(URLS.CLARIO, "auto", data);
    setIsRecommended(true);
    setSearchContent(data);
    backupInput.current = data;
  };

  const handleSubmitQuestion = async (e) => {
    e.preventDefault();
    const isEmpty = EMPTY.test(prompt);

    if (!isValidLogin() || isEmpty) return;
    if (isValidLogin() && user.id) {
      if (user.tutor_cnt === 0) {
        setAlertSetting((prev) => ({
          ...prev,
          alertTxt: `이용 가능 횟수: 0개\n이용중인 상품이 없습니다.\n 결제페이지로 이동하시겠습니까?`,
          double: true,
          btnTxt: "결제하기",
          onConfirm: () => {
            if (typeof prev.onConfirm === "function") {
              prev.onConfirm();
            }
            navigation("/settings/products", {
              state: {
                is_completed: false,
                is_writed: false,
                from_chat: "group",
                his_cnt: 0,
              },
            });
          },
        }));
        return;
      }

      let pathSegments = location.pathname.split("/");
      // basePath를 정의 (예: "/tutor")
      let basePath = `/${pathSegments[1]}`;

      if (
        pathSegments.length > 2 &&
        pathSegments[2].match(/^[0-9]+-[A-Z0-9]+$/)
      ) {
      } else {
        basePath = basePath === "/socrates" ? basePath : "/tutor";
      }
      const isBlank = !prompt ? true : false;
      if (fetching || isBlank) return;
      if (!paramId) {
        const inputValue = prompt;
        handleSample(inputValue);
        return;
      }

      const inputValue = prompt;
      // searchRef.current = "";
      // inputRef.current.value = null;
      let conversation = {
        question: inputValue,
        action: "chat",
        answer: "",
        user_eva: {
          simple_eva: null,
          eva: null,
        },
      };
      // setHistory((prev) => [...prev, conversation]);
      setSearchContent(inputValue);
      backupInput.current = inputValue;
      let finalIdx = history.length - 1;
      setQueryString((prev) => ({
        ...prev,
        query: inputValue,
        messages:
          history.length !== 0
            ? [
                ...prev.messages,
                {
                  role: "assistant",
                  content:
                    history[finalIdx].response !== undefined
                      ? JSON.stringify(history[finalIdx].answer)
                      : "",
                },
                {
                  role: "user",
                  content: inputValue,
                },
              ]
            : [
                {
                  role: "user",
                  content: inputValue,
                },
              ],
        persona: persona,
      }));
      return;
    }
    setIsLogin(true);
  };

  const handleFloat = (e, idx) => {
    const isSave = e.target.id === "save";

    if (!isSave) return;

    handleSubmitFeedback(idx);
  };

  const [persona, setPersona] = useState(null);
  const [personaList, setPersonaList] = useState([]);

  const handleSelect = (e) => {
    // 로그인 체크를 먼저 수행 (혹시 onMenuOpen에서 놓친 경우 대비)
    if (!isValidLogin()) {
      moveToLogin();
      return;
    }

    let targetValue = e.value;
    setPersona(targetValue);
    setUser((prev) => ({
      ...prev,
      tone: e.value,
    }));
  };

  useEffect(() => {
    if (user.tone) {
      const selectedOption = personaList?.find(
        (option) => option.value === user.tone
      );
      if (selectedOption) {
        setPersona(selectedOption.value);
      }
    }
  }, [user.tone, personaList]);

  // 좋아요/싫어요
  const handleClickReaction = async (e, idx) => {
    const isLike = e.target.id === "1";
    const alreadyReacted =
      history[idx].user_eva?.simple_eva === (isLike ? 1 : 0);

    if (alreadyReacted) return; // 이미 같은 반응을 한 경우 아무 작업도 수행하지 않음

    const item = history[idx];

    if (!item) return;

    setHistory((prev) =>
      prev.map((chat, i) => {
        if (i !== idx) return chat;

        return {
          ...chat,
          user_eva: {
            eva: "",
            simple_eva: isLike ? 1 : 0,
          },
        };
      })
    );

    if (feedbackRef.current?.[idx] == null) return;
    feedbackRef.current[idx].value = "";

    const reqData = {
      response_id: item.response_id,
      simple_eva: isLike ? 1 : 0,
      eva: "",
    };

    await touchAPI("PUT", URLS.REACTION, reqData);
  };

  // const [isReload, setIsReload] = useState(false);
  const isReloadRef = useRef(false);
  // 답변 재요청
  const handleReloadAnswer = async (e, item) => {
    isReloadRef.current = true;
    setHistory((prev) => {
      return prev.map((his, i) => {
        if (i === prev.length - 1) {
          return {
            ...his,
            response: "",
          };
        }
        return his;
      });
    });

    setQueryString((prevState) => ({
      ...prevState,
      query: item.input_text,
      messages:
        prevState.messages.length > 2
          ? prevState.messages.slice(0, -1)
          : prevState.messages,
    }));
    setSearchContent(item.input_text);
    backupInput.current = item.input_text;
  };

  const handleSubmitFeedback = async (index) => {
    const targetValue = feedbackRef.current[index].value;
    const reqData = {
      response_id: history[index].response_id,
      simple_eva: history[index].user_eva.simple_eva,
      eva: targetValue,
    };

    if (targetValue === "") {
      return false;
    } else if (targetValue.length > 100) {
      setWarnSetting({
        ...warnSetting,
        warningTxt: "최대 100글자까지만 입력이 가능합니다.",
        onClose: () => {
          clearWarnState();
        },
      });
      return false;
    } else {
      setHistory((prev) =>
        prev.map((chat, i) => {
          if (i !== index) return chat;

          return {
            ...chat,
            user_eva: {
              ...chat.user_eva,
              eva: targetValue,
            },
          };
        })
      );

      await touchAPI("PUT", URLS.REACTION, reqData);
    }
  };

  const toggleRefs = (item, idx) => {
    setHistory((prev) => {
      const copy = [...prev];
      const updatedItem = { ...copy[idx] };
      updatedItem.isShowDetail = !updatedItem.isShowDetail;
      copy[idx] = updatedItem;
      return copy;
    });
  };
  const lastScrollY = useRef(0);
  // 스크롤 이벤트 핸들러
  const handleScroll = () => {
    const currentScrollY = scrollRef.current.scrollTop;
    if (currentScrollY <= lastScrollY.current) {
      setIsFreeScroll(true);
    }

    // 현재 스크롤 위치를 저장
    lastScrollY.current = currentScrollY;
  };

  const linkToPage = (url) => {
    window.open(url, "_blank");
  };

  const [targetRef, setTargetRef] = useState({
    IMG_Description: null,
    IMG_SRC: null,
    IMG_TITLE: null,
  });
  useEffect(() => {
    const fetchPromptAndWelcomeData = async () => {
      try {
        const url = `${URLS.PROMPT_MSG}?kind=tutor`;
        const promptData = await touchAPI("GET", url);
        if (promptData) {
          setPromptValue(promptData.content);
        }

        const welcomeUrl = `${URLS.GREETING_MSG}?kind=tutor`;
        const welcomeData = await touchAPI("GET", welcomeUrl);
        if (welcomeData) {
          setWelcomeValue(welcomeData);
        }

        const personaUrl = `${URLS.PERSONA}`;
        const personaData = await touchAPI("GET", personaUrl);
        if (personaData) {
          const data = personaData.persona_list || [];
          const copy = data?.map((item) => ({
            label: item.tone,
            value: item.tone,
          }));
          setPersonaList([...copy]);
        }
      } catch (error) {
        setAlertSetting((prev) => ({
          ...prev,
          alertTxt: `서버 오류입니다.\n관리자에게 문의 바랍니다.`,
          btnTxt: "닫기",
        }));
      }
    };

    fetchPromptAndWelcomeData();

    const container = scrollRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
      return () => container.removeEventListener("scroll", handleScroll);
    }
  }, []); // 의존성 배열에 빈 배열을 넣어 처음 렌더링될 때만 실행되도록 설정

  useEffect(() => {
    if (history.length === 0) return;
    const lastIdx = history?.length === 0 ? 0 : history?.length - 1;
    if (history[lastIdx]?.input_text !== "") {
    }
    if (history.length > 0 && queryString.messages.length === 0) {
    }
  }, [history]);

  const [isStoredHistory, setIsStoredHistory] = useState(false);

  const [listPage, setListPage] = useState({
    offset: 1,
    limit: 50,
    total: 0,
  });

  const getGroupList = async (url) => {
    const groupData = await touchAPI(
      "GET",
      url,
      `?offset=${listPage.offset}&limit=${listPage.limit}`
    );
    if (groupData) {
      const newData = groupData?.group_list?.map((item) => ({
        ...item,
        isClicked: false,
        isEdit: false,
      }));
      if (newData) {
        setList(newData);
        setListPage((prev) => ({
          ...prev,
          total: groupData.total_count,
        }));
      }
    }
  };

  const [isShowShareModal, setIsShowShareModal] = useState(false);

  const getHistory = async (target, url, id) => {
    if (target === "new") return;
    const chatData = await touchAPI("GET", url, id);
    const chattingList = chatData?.chat_list;
    // setHistory([...chattingList])
    if (chattingList) {
      setIsUpdate(!isUpdate);
      setHistory((prev) => {
        const copy = [...chattingList];
        const newCopy = copy.map((item) => ({
          id: item.id,
          response_id: item.response_id,
          last_result: item.last_result,
          recommended_questions: item.recommended_questions,
          latency: item.latency,
          input_text: item.input_text,
          reference: item.reference,
          response: item.response,
          images: item.images,
          action: item.action,
          sub_action: item.sub_action,
          question_count: item.question_count,
          followup_count: item.followup_count,
          from_chat: item.from_chat,
          user_eva: item.user_eva,
        }));
        return newCopy;
      });
    }
  };

  useEffect(() => {
    const data = location.pathname.split("/");

    const params = data[2];
    const path = data[1];
    const mode = location.state;

    if (params) {
      const isStored = mode?.from_chat?.includes("storage") ? true : false;
      const isGroupchat = mode?.from_chat?.includes("group") ? true : false;
      setIsStoredHistory(isStored);
      // const chatData = await touchAPI('GET', jsonData?.state?.from_chat === 'group' ? URLS.ADD_GROUP : URLS.STORAGE_HISTORY, `/${jsonData.params}`)
      getHistory(
        mode?.from_chat,
        mode?.from_chat === "group" ? URLS.ADD_GROUP : URLS.STORAGE_HISTORY,
        `/${params}`
      );
    } else {
      setHistory([]);
    }
  }, [location]);

  useEffect(() => {
    if (history.length === 0) return; // 대화 내역이 없으면 스크롤하지 않음

    // 자식 컴포넌트에서 렌더링된 데이터가 변경될 때마다 부모 컴포넌트의 높이를 변경하는 코드
    scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
  }, [history.length]); // history.length가 변경될 때만 실행

  useEffect(() => {
    if (!isFreeScroll) {
      setIsUpdate(!isUpdate);
    }
  }, [wordLng, history.length, isFreeScroll]);

  useEffect(() => {
    if (searchContent) {
      setIsClickedHistory(false);
      setIsUpdate(!isUpdate);
      fetchData(URLS.CLARIO, "auto", searchContent, paramId);
    }
  }, [searchContent]);
  /**
   * warning Handler
   */
  const clearWarnState = () => {
    setWarnSetting({
      ...warnSetting,
      warningTxt: "",
    });
    setIsWarning(false);
  };
  const [isWarning, setIsWarning] = useState(false);
  const [warnSetting, setWarnSetting] = useState({
    warningTxt: "",
    onClose: () => clearWarnState(),
  });
  useEffect(() => {
    if (warnSetting.warningTxt !== "") {
      setIsWarning(true);
    }
  }, [warnSetting.warningTxt]);

  return (
    <Style open={openNav}>
      <main className="ctn-wrp tutor-wrp">
        <div
          className={`rd-wrp ${
            history?.length === 0 ? "flex flex-col" : "mt-8"
          } ${fetching ? "mb-8" : ""}`}
          ref={scrollRef}
        >
          <div
            className={`rd-inr flx-box ${
              history?.length === 0 && !fetching ? "emp-wrp" : ""
            }`}
            style={history?.length === 0 ? { padding: 0 } : null}
          >
            <Chat
              storage={isStoredHistory}
              handleReloadAnswer={handleReloadAnswer}
              feedbackRef={feedbackRef}
              history={history}
              setHistory={setHistory}
              fetching={fetching}
              handleClickReaction={handleClickReaction}
              handleCopy={handleCopy}
              handleSample={handleSample}
              linkToPage={linkToPage}
              setTargetRef={setTargetRef}
              toggleRefs={toggleRefs}
              setIsUpdate={setIsUpdate}
              wordLng={wordLng}
              setWordLng={setWordLng}
              handleFloat={handleFloat}
              isReload={isReloadRef.current}
            />
            {history.length === 0 && !fetching && (
              <>
                <div className="emp-box flx-box sep-elm">
                  <div className="emp-box__top">
                    {!isMobile && (
                      <img
                        src="https://img.dongascience.com/air/icon_logo.svg"
                        alt="logo-img"
                        className="emp-box__img"
                      />
                    )}
                    <p className="logo-txt md:min-h-[76px]">
                      {welComeVAlue.greeting}
                    </p>
                  </div>
                  <div className="division"></div>
                  <div className="emp-box__btm">
                    <div className="flx-box bubble-wrp">
                      <img src={Bubble} alt="icon_bubble" />
                      <p className="bubble-txt">이런 질문을 할 수 있어요</p>
                    </div>
                    <Sample setData={handleSample} />
                  </div>
                </div>
              </>
            )}
          </div>
          {!fetching && history?.length > 0 && (
            <div
              className="save-history-wrp crs-btn"
              onClick={() => setIsShowShareModal(true)}
            >
              <div className="save-history__btn">공유</div>
            </div>
          )}
          {fetching && searchContent && <LoadingForm />}
        </div>

        <SharedChatInput
          prompt={prompt}
          isTutor={true}
          placeholder={promptValue}
          onChange={(e) => {
            setPrompt(e.target.value);
          }}
          onClick={(e) => {
            if (!isValidLogin()) return moveToLogin();
            if (user.tutor_cnt === 0) return handleLinkToProducts(e);
          }}
          onSubmit={handleSubmitQuestion}
          fetching={fetching}
          stopFetching={handleAbort}
          showFreeScrollButton={
            !fetching && isFreeScroll && history.length !== 0
          }
          onFreeScrollClick={() => {
            setIsUpdate(!isUpdate);
            setIsFreeScroll(false);
          }}
          speechInput={<BasicSpeech onUpdateTranscript={setTextFunction} />}
          selectBox={
            isValidLogin() ? (
              <SelectBox
                onlyTxt
                paint
                placeholder="페르소나정의"
                defaultValue={personaList?.find(
                  (option) => option.value === user.tone
                )}
                options={personaList}
                mainColor="#E8E5E1"
                subColor="rgba(83, 40, 223, 1)"
                emptyColor="rgba(83, 40, 223, 1)"
                handleChange={handleSelect}
              />
            ) : (
              <div
                onClick={() => setIsLogin(true)}
                style={{
                  border: "1px solid rgba(83, 40, 223, 1)",
                  borderRadius: "2rem",
                  backgroundColor: "rgba(83, 40, 223, 1)",
                  color: "#E8E5E1",
                  minHeight: "32px",
                  height: "32px",
                  display: "flex",
                  alignItems: "center",
                  padding: "2px 17px 2px 10px",
                  cursor: "pointer",
                  fontSize: "10px",
                  fontWeight: "400",
                  lineHeight: 1.5,
                  opacity: 1,
                  position: "relative",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  boxSizing: "border-box",
                  transition: "border-color 0.15s ease-in-out",
                  outline: "none",
                }}
                onMouseEnter={(e) => {
                  e.target.style.borderColor = "#E8E5E1";
                }}
                onMouseLeave={(e) => {
                  e.target.style.borderColor = "rgba(83, 40, 223, 1)";
                }}
              >
                페르소나정의
              </div>
            )
          }
        />
        {isWarning && <Warning settings={warnSetting} />}

        {isShowShareModal && (
          <CreateUrl
            onClose={() => setIsShowShareModal(!isShowShareModal)}
            target={isStoredHistory ? "storage_id" : "group_id"}
            id={paramId}
          />
        )}
      </main>
    </Style>
  );
};
export default Tutor;

const Style = styled.div`
  @media screen and (min-width: 1024px) {
    height: 100%;
  }
  @media screen and (min-width: 768.99px) and (max-width: 1023.99px) {
    height: 100%;
    .inp-wrp {
      padding: ${(props) => (props.open ? "0 12% 0% 15%" : "0 10% 0% 10%")};
    }
  }
  @media screen and (max-width: 768.98px) {
    // height: calc(100% - 264px);
    // height: calc(100% - 144px); // footer 제거로 높이 조절
    height: 100%; // footer 제거로 높이 조절
    .inp-wrp {
    }
  }
`;
